<div class="zs-display-flex select zs-select-wrapper" [ngClass]="labelInverse ? 'zs-text-inverse': 'zs-text-headline'">
  @if (label) {
    <label class="select-label">
      @if (!showLabelTooltip) {
        <span>{{ label }}</span>
      } @else {
        {{label | applyEllipses:labelEllipsisConstant}}
        @if (label.length > labelEllipsisConstant) {
          <zs-tooltip handle-transform>
            <zs-tooltip-content class="zs-size-xs tooltip-content">
              {{label}}
            </zs-tooltip-content>
          </zs-tooltip>
        }
      }
      @if (!isRequired && enableSearch !== 'true' && showOptionalText) {
        <span class="zs-font-weight-normal">
          <i translate>{{ common_labels.OPTIONAL_IN_PARANTHESIS }}</i>
        </span>
      }
    </label>
  }
  <p-is-zs-multiselect mode="action"
    class="zs-margin-0 zs-action-field zs-select zs-master-style background-color-class" #zsSelect
    [labelKey]="'displayLabel'" [valueKey]="'value'" [options]="source" [selectedValues]="selectedOptions"
    [ngClass]="touched ? inputClass : ''" [style]="customStyle" [flippable]="flippable"
    [hideOnScroll]="flippable || hideOnScroll" [disabled]="disabled" (change)="onChange($event)"
    (beforeopen)="beforeOpen()" (onfocus)="onFocusOut($event)" [noRecordsText]="noRecordsText" clear>
  </p-is-zs-multiselect>
  @if (touched && inErrorState) {
    <p [ngClass]="inputClass" class="message-margin zs-message">{{errorMessage}}</p>
  }
</div>